import React from 'react'

const Chile = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="45"
            height="40"
            viewBox="0 0 32 30"
            x="1"
            y="1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            maskUnits="userSpaceOnUse"
            {...props}
        >
            <g clipPath="url(#z)">
                <mask
                    id="z"
                    width="32"
                    height="30"
                    x="1"
                    y="1"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#C4C4C4"
                        d="M10 18.38c4.97 0 9-3.9 9-8.7C19 4.9 14.97 1 10 1S1 4.89 1 9.69c0 4.8 4.03 8.69 9 8.69Z"
                    />
                </mask>
                <g mask="url(#z)">
                    <path fill="#fff" d="M33.3.61H1V18.8h32.3V.61Z" />
                    <path fill="#364396" d="M10.42.61H1V18.8h9.42V.61Z" />
                    <path fill="#C22A2A" d="M33.3 9.7H1v9.1h32.3V9.7Z" />
                    <path
                        fill="#fff"
                        d="m8.16 6.56 1.38-.97H7.82L7.3 4.01 6.76 5.6h-1.7l1.38.97-.52 1.56 1.38-.96 1.38.96-.52-1.56Z"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M1 1h18v17.38H1z" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Chile
